import {getInfo, login, logout} from '@/api/login'
// import {getToken, removeToken, setToken} from '@/utils/auth'
import {default as api} from '../../utils/api'
import store from '../../store'
import router from '../../router'
import da from "element-ui/src/locale/lang/da";
// import {FALSE, TRUE} from "node-sass";

const user = {
  state: {
    username:'',
    nickname: "",
    userId: "",
    avatar: './assets/jiayoubao.png',
    role: '',
    roleId:null,
    menus: [],
    permissions: [],
    phoneCheck:0,
    isManager:false,
    roleType:3,// 1-manager; 2-商务; 3-客户
  },
  mutations: {
    CHECK_PHONE:(state,result)=>{
      state.phoneCheck = result;
    },
    SET_USER: (state, userInfo) => {
      state.username = userInfo.username;
      state.nickname = userInfo.nickname;
      state.userId = userInfo.userId;
      state.role = userInfo.roleName;
      state.roleId = userInfo.roleId;
      state.menus = userInfo.menuList;
      state.permissions = userInfo.permissionList;
      state.phoneCheck = userInfo.phoneCheck;
      if (userInfo.roleId === 1 ||userInfo.roleId === 2 || userInfo.roleId ===6){
        state.isManager = true;
        state.roleType = 1;
      }else if(userInfo.roleId === 4 || userInfo.roleId === 5){
        state.roleType = 3;
      }else  if(userInfo.roleId === 3){
        state.roleType = 2;
      }
    },
    RESET_USER: (state) => {
      state.username = "",
      state.nickname = "";
      state.userId = "";
      state.role = '';
      state.roleId = null;
      state.menus = [];
      state.permissions = [];
      state.isManager =false;

    }
  },
  actions: {
    PhoneCheck({commit,state},result){
      return new  Promise((resolve,reject) =>{
        commit('CHECK_PHONE', result);
      } )
    },
    // 登录
    Login({commit, state}, loginForm) {
      return new Promise((resolve, reject) => {
        api({
          url: "user/login",
          method: "post",
          data: loginForm
        }).then(data => {
          console.log(data);
          if (data.data) {
             localStorage.setItem("token",data.data.token);
             localStorage.setItem("roleId",data.data.roleId);
             localStorage.setItem("userId",data.data.userId);
             localStorage.setItem("hadLogin","1");
            //生成路由
            let userPermission = data.data.permission ;
            store.dispatch('GenerateRoutes', userPermission).then(() => {
              //生成该用户的新路由json操作完毕之后,调用vue-router的动态新增路由方法,将新路由添加
              router.addRoutes(store.getters.addRouters)
            })
            // if (1=== data.sms){
            //   commit('CHECK_PHONE', 1);
            // }else {
            //   commit('CHECK_PHONE', 0);
            // }
            //cookie中保存前端登录状态
            // setToken();

          }
          resolve(data.data);
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 获取用户信息
    GetInfo({commit, state}) {
      return new Promise((resolve, reject) => {
        api({
          url: '/user/getInfo',
          method: 'post'
        }).then(data => {
          console.log("set_user"+JSON.stringify(data));
          //储存用户信息
          commit('SET_USER', data.data);
          //cookie保存登录状态,仅靠vuex保存的话,页面刷新就会丢失登录状态
          // setToken();
          //生成路由
          let userPermission = data.data ;
          store.dispatch('GenerateRoutes', userPermission).then(() => {
            //生成该用户的新路由json操作完毕之后,调用vue-router的动态新增路由方法,将新路由添加
            router.addRoutes(store.getters.addRouters)
          })
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({commit}) {

      return new Promise((resolve) => {
        commit('RESET_USER')
        localStorage.removeItem("roleId");
        localStorage.removeItem("userId");
        localStorage.removeItem("hadLogin");
        // removeToken()
        resolve();

        // api({
        //   url: "user/logout",
        //   method: "post"
        // }).then(data => {
        //
        // }).catch(() => {
        //   commit('RESET_USER')
        //   // removeToken()
        // })
      })
    },
    // 前端 登出
    FedLogOut({commit}) {
      return new Promise(resolve => {
        localStorage.removeItem("token");
        localStorage.removeItem("roleId");
        localStorage.removeItem("userId");
        localStorage.removeItem("hadLogin");
        commit('RESET_USER')
        // removeToken()
        resolve()
      })
    }
  }
}
export default user
